module.exports = "/_next/static/images/de-69ccebc79b1b1a91264cd7db692525e8.svg";